export default "__VITE_ASSET__1GVi8pDa__"